
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1afi9_1x8op_9",
  "hidden": "awsui_hidden_1afi9_1x8op_40",
  "no-items": "awsui_no-items_1afi9_1x8op_43"
};
  